<template>
  <div v-if="showDeleteButton">
    <span class="pull-left">
      <slot name="label"></slot>
    </span>
    <span class="upload-actions">
      <a class="delete" @click.prevent="$emit('deleted', file)">
        {{ lang.get('files.actions.delete') }}
      </a>
    </span>
  </div>
</template>

<script>
export default {
  inject: ['lang'],
  props: {
    file: {
      type: Object,
      required: true
    },
    captionMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showDeleteButton() {
      return (
        ['completed', 'ok'].includes(this.file.status) ||
        (this.file.status === 'failed' && this.captionMode)
      );
    }
  }
};
</script>
